import * as React from "react";

function SvgWarning(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
        <path
          data-name="Shape Copy 2"
          d="M13 0a13 13 0 1013 13A13.015 13.015 0 0013 0zm0 17.875a.813.813 0 01-.812-.812V5.688a.812.812 0 111.625 0v11.375a.813.813 0 01-.813.812zm0 3.249a.812.812 0 11.812-.812.813.813 0 01-.812.813z"
          fill="#ff9800"
        />
      </svg>
    </span>
  );
}

export default SvgWarning;
